import React from "react";
import { Link } from "react-router-dom";
import { FaEdit, FaEye } from "react-icons/fa";
import { Badge } from "react-bootstrap";
import Select from "../../components/Select/Select";
import "../Query/Query.css";
import InternalComments from "./InternalComments";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const StakeHolderQueryView = ({
  attchement,
  query_details,
  suggestions = [],
  statusUpdateHandler,
  isUpdateStatus,
  setIsUpdateStatus,
  viewHandler, // 🔹 new prop to handle add-suggestion submit
}) => {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between">
        <span className="query-type text-capitalize">
          Query No. {query_details.id}
        </span>
      </div>

      {/* Student and Stakeholder Details */}
      <div className="table-responsive mt-3" style={{ minHeight: "250px" }}>
        <table className="table table-striped">
          <tbody>
            <tr>
              <th>Student Name</th>
              <td>{query_details.student_name}</td>
              <th>Admission No</th>
              <td>{query_details.id_number}</td>
            </tr>
            <tr>
              <th>Class</th>
              <td>{query_details.student_class}</td>
              <th>Request Type</th>
              <td>{query_details.request_type}</td>
            </tr>
            <tr>
              <th>School</th>
              <td>{query_details.school_name}</td>
              <th>Father Name</th>
              <td>{query_details.stakeholder_name}</td>
            </tr>
            <tr>
              <th>Father Email</th>
              <td>{query_details.stakeholder_email}</td>
              <th>Father Mobile</th>
              <td>{query_details.stakeholder_mob}</td>
            </tr>
            <tr>
              <th>Request Received</th>
              <td>{query_details.created_at}</td>
              <th>Replied On</th>
              <td>
                {query_details.replies &&
                  query_details.replies.length > 0 &&
                  query_details.replies[0].created_at}
              </td>
            </tr>
            <tr>
              <th>Replied By</th>
              <td>
                {query_details.replies &&
                  query_details.replies.length > 0 &&
                  query_details.replies[0].reply_user.name}
              </td>
              <th>Request Status</th>
              <td>
                {isUpdateStatus ? (
                  <div className="row" style={{ overflow: "hidden" }}>
                    <div className="col-md-10">
                      <Select
                        name="reply_status"
                        id="reply_status"
                        onChangeHandler={(e) =>
                          statusUpdateHandler(e.target.value, query_details.id)
                        }
                        options={[
                          { id: "", name: "Select Status" },
                          { id: "0", name: "Open" },
                          { id: "1", name: "Closed" },
                          { id: "2", name: "Closed and follow-up required" },
                          { id: "3", name: "Acknowledged" },
                        ]}
                      />
                    </div>
                    <div className="col-md-1">
                      <i
                        className="fa-solid fa-xmark p-2"
                        style={{
                          color: "var(--color-danger-text)",
                          cursor: "pointer",
                          fontSize: "20px",
                        }}
                        onClick={() => setIsUpdateStatus(false)}
                      ></i>
                    </div>
                  </div>
                ) : (
                  <React.Fragment>
                    <Badge
                      className={`bg-${
                        {
                          0: "success",
                          1: "danger",
                          2: "warning",
                          3: "info",
                        }[query_details.reply_status]
                      } text-uppercase`}
                    >
                      {
                        {
                          0: "OPEN",
                          1: "CLOSED",
                          2: "CLOSED and follow-up required",
                          3: "ACKNOWLEDGED",
                        }[query_details.reply_status]
                      }
                    </Badge>
                    <FaEdit
                      className="edit-icon cursor-pointer ms-2"
                      style={{ color: "var(--color-link)", fontSize: "16px" }}
                      onClick={() => setIsUpdateStatus(true)}
                    />
                  </React.Fragment>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Query Details */}
      <div
        className="query-container mt-3 p-3 border rounded"
        style={{ backgroundColor: "rgb(238 232 232)" }}
      >
        <div className="query-message">
          <span>{query_details.details}</span>
        </div>
      </div>

      <div className="mt-2">
        <h5>Reply Details:</h5>
        {query_details.replies && query_details.replies.length > 0 && (
          <div
            // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(query_details.replies[0].reply_message),
            }}
          />
        )}
      </div>

      {/* Attachments */}
      {attchement && (
        <div className="mt-2">
          <Link onClick={() => window.open(attchement)}>
            View Attachment: <FaEye />
          </Link>
        </div>
      )}
      {query_details.replies &&
        query_details.replies.length > 0 &&
        query_details.replies[0].reply_attachment && (
          <div className="mt-2">
            <Link
              onClick={() =>
                window.open(query_details.replies[0].reply_attachment)
              }
            >
              View Reply Attachment: <FaEye />
            </Link>
          </div>
        )}
      {/* 🗨️ Internal Comment Section */}
      <InternalComments
        suggestions={suggestions}
        user={user}
        query_details={query_details}
        viewHandler={viewHandler}
      />
    </React.Fragment>
  );
};

export default StakeHolderQueryView;
